<template>
    <b-modal id="modal-phone" centered class="modal-phone">
      <div class="modal-phone-itens">
        <button
          class="modal-phone-itens-close"
          @click="$bvModal.hide('modal-phone')"
        >
        <img src="@/assets/img/close.png" alt="close" width="30">
        </button>
      </div>
      <div class="modal-phone-content">
        <h3>Telemóvel</h3>
        <form @submit.prevent="updatePhone()">
            <div class="row">
                <div class="col-md-12">
                    <input type="text" name="phone" v-model="phone" placeholder="Alterar nº de telefone" maxlength="9"  @keypress="onlyNumbers">
                </div>
            </div>
            <div class="content-input-button">
                <div class="btn btn-send">
                    <button type="submit">gravar</button>
                </div>
            </div>
        </form>
      </div>
      <ConfirmPhone />
    </b-modal>
  </template>
  
  <script> 
  import axios from 'axios';
  import ConfirmPhone from './ConfirmPhone.vue';

  export default {
    data() {
      return {
        phone: '',
        hash: ''
      };
    },
    components: {
      ConfirmPhone,
    },
    methods: {
      async updatePhone(){
        if (this.phone.charAt(0) !== '9') {
            this.$swal.fire({
                type: 'error',
                title: 'Erro',
                text: 'O número de telemóvel deve começar com 9.',
                timer: 3000,
            });
            return;
        }
        if (this.phone.length !== 9) {
            this.$swal.fire({
                type: 'error',
                title: 'Erro',
                text: 'O número de telemóvel deve ter 9 digitos.',
                timer: 3000,
            });
            return;
        }
        const data = {
          phone: this.phone,
          id: localStorage.getItem('token') || null,
        }
        await axios.post('/api/v1/user/update-phone', data)
        .then((response) => {
          if(response.data.success === true){
            this.hash = response.data.data.hash;
            localStorage.setItem('hash', response.data.data.hash);
            this.$bvModal.show('modal-confirmphone');
            this.$store.dispatch('getUser');
          }else{
            this.$swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: 'Ocorreu um erro ao alterar os dados!',
            })
          }
        }).catch((error) => {
          console.log(error);
          this.$swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Ocorreu um erro ao alterar os dados!',
          })
        })
      },
      onlyNumbers(event) {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          event.preventDefault();
        }
      }
    }
  };
  </script>
  
  <style lang="scss">
  #modal-phone {
    .modal-header,
    .modal-footer {
      display: none;
    }
    .modal-dialog {
      max-width: 825px;
      margin: auto!important;;
      @media screen and (max-width: 991px) {
        max-width: 384px;
      }
    }
    .modal-content {
      border-radius: 0;
      border: 0;
      background-color: #F6F6F6!important;
    }
    .modal-body {
      height: 463px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      @media (max-width: 991px) {
        padding: 50px 20px;
        height: 463px;
      }
    }
  }
  .modal-phone {
    &-itens {
      display: flex;
      flex-direction: row-reverse;
      align-items: center;
      justify-content: space-between;
      &-close {
        position: absolute;
        right: -45px;
        top: -40px;
        width: 83px;
        height: 83px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: black;
        border: 1px solid black;
        border-radius: 50%;
        transition: 500ms;
        @media (max-width: 991px) {
          top: 20px;
          right: 20px;
          width: 40px;
          height: 40px;
          svg {
            max-width: 15px;
          }
        }
        &:hover,
        &:focus {
          opacity: 0.6;
        }
      }
    }
    &-content{
        max-height: 290px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        gap: 20px;
        form{
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 34px;
            .row{
                display: flex;
                justify-content: space-between;
                align-items: center;
                flex-direction: row;
                input{
                    width: 100%;
                    height: 50px;
                    border: none;
                    background-color: var(--white);
                    border: 1px solid #B8B8B8;
                    text-align: center;
                    border-radius: 5px;
                    font-size: 18px;
                    font-family: "Font Regular";
                    color: #B8B8B8;
                    &::placeholder{
                        font-size: 18px;
                        font-family: "Font Regular";
                        color: var(--black);
                    }
                }
            }
        }
    }
  }
.content-input-button{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    button{
        width: 280px;
        height: 56px;
        border: none;
        background: rgb(254,206,9);
        background: linear-gradient(90deg, rgba(254,206,9,1) 0%, rgba(245,137,31,1) 100%);
        text-align: center;
        border-radius: 10px;
        padding: 0 20px;
        font-size: 18px;
        font-family: "Font Regular";
        color: black;
        transition: 500ms;
        text-transform: uppercase;
    }
}
  </style>